export const timezone = [
  {
    title: "UTC-09:00: Alaska",
    value: "America/Anchorage",
  },
  {
    title: "UTC-08:00: Pacific Standard Time (PST/PDT)",
    value: "America/Los_Angeles",
  },
  {
    title: "UTC-07:00: Mountain Standard Time (MST/MDT)",
    value: "America/Denver",
  },
  {
    title: "UTC-06:00: Central Standard Time (CST/CDT)",
    value: "America/Chicago",
  },
  {
    title: "UTC-05:00: Eastern Standard Time (EST/EDT)",
    value: "America/New_York",
  },
  {
    title: "UTC-04:00: Atlantic Standard Time (AST/ADT)",
    value: "America/Halifax",
  },
  {
    title: "UTC-03:30: Newfoundland Standard Time (NST/NDT)",
    value: "America/St_Johns",
  },
];
